import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from 'modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';
import { JOB_FUNCTIONS_CHECKBOX_OPTIONS } from 'utils/constants/general/jobFunctions';

type Props = {
  variant?: SearchFacetVariant;
};
export function JobKeywordsFacet({ variant = 'dropdown' }: Props) {
  // @ts-expect-error Fix type
  const selectedFacetValues = useSearchFacetSelectedValues('functions');
  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="functions"
      icon="alternate-shapes"
      label={
        <>
          {getText('Job Function')}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="functions"
        initialValue={selectedFacetValues}
        options={JOB_FUNCTIONS_CHECKBOX_OPTIONS()}
        searchable
      />
    </FacetVariant>
  );
}
